// src/pages/P4PDashboardPage.tsx
import React from "react";
import TableauEmbed from "../components/TableauEmbed";
import { TABLEAU_P4P } from "../Config/Tableau";

const P4PDashboardPage: React.FC = () => {
  const { workbook, view, height } = TABLEAU_P4P;

  return (
    <div style={{ padding: 16 }}>
      <div style={{ border: "1px solid #ddd", borderRadius: 8, overflow: "hidden" }}>
        <TableauEmbed workbook={workbook} view={view} height={height} />
      </div>
    </div>
  );
};

export default P4PDashboardPage;
